'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Use `Heading` to render h1-6 elements with heading text styles.
 *
 * @example
 * <Heading data-size='lg' level={2}>Heading</Heading>
 */
const Heading = forwardRef(function Heading({ level = 2, className, asChild, ...rest }, ref) {
    const Component = asChild ? Slot : `h${level}`;
    return (jsx(Component, { className: cl(`ds-heading`, className), ref: ref, ...rest }));
});

export { Heading };
